import React from 'react';
import ReactDOM from 'react-dom/client';
import thunk from 'redux-thunk';
import App from './App';
import './style/ui.scss'
import { applyMiddleware, combineReducers, legacy_createStore as createStore } from 'redux';
import { Provider } from 'react-redux';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { SnackbarProvider } from 'notistack';
import theme from './style/theme';
import { HomeReducer } from './Component/Home/Reducer/HomeReducer';
import { ServiceReducer } from './Component/Home/SubComponent/Main/Index/Reducer/ServiceReducer';
import { ServiceInfoReducer } from './Component/Home/SubComponent/Main/Info/Reducer/ServiceInfoReducer';
import { HeaderReducer } from './Component/Home/SubComponent/Header/Reducer/HeaderReducer';
import { RouterReducer } from './Component/Home/SubComponent/Main/Router/Reducer/RouterReducer';
import { OrderReducer } from './Component/Home/SubComponent/Main/Orders/Reducer/OrderReducer';
import { PaymentsReducer } from './Component/Home/SubComponent/Main/Payments/Reducer/PaymentsReducer';
import { PaymentDialogReducer } from './Component/Home/SubComponent/Header/SubComponent/Reducer/PaymentDialogReducer';


const reducers = combineReducers({
  home : HomeReducer,
  service : ServiceReducer,
  info : ServiceInfoReducer,
  header : HeaderReducer,
  router : RouterReducer,
  orders : OrderReducer,
  payments : PaymentsReducer,
  paymentDialog : PaymentDialogReducer
});

const store = createStore(reducers, applyMiddleware(thunk));


const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);


root.render(
  <Provider store={store} >
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div dir='rtl'>
        <SnackbarProvider autoHideDuration={3000}>
          <App />
        </SnackbarProvider>

      </div>
    </ThemeProvider>
  </Provider>

);